<template>
  <!-- The section above (`from`) flows into the section below (`to`) along a rising
       "fitness trending up" curve, traced with the brand gradient stroke. Decorative only. -->
  <div class="SectionDivider" :style="{ background: to }" aria-hidden="true">
    <svg class="SectionDivider__svg" viewBox="0 0 1440 140" preserveAspectRatio="none">
      <defs>
        <linearGradient :id="gradientId" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stop-color="#fc4c01" />
          <stop offset="55%" stop-color="#ffd27a" />
          <stop offset="100%" stop-color="#b6ffc9" />
        </linearGradient>
      </defs>
      <path :fill="from" d="M0 112 C 240 112 320 74 480 78 C 660 82 740 44 960 48 C 1160 52 1240 22 1440 28 L1440 0 L0 0 Z" />
      <path
        class="SectionDivider__line"
        fill="none"
        :stroke="`url(#${gradientId})`"
        stroke-width="2.5"
        stroke-linecap="round"
        vector-effect="non-scaling-stroke"
        d="M0 112 C 240 112 320 74 480 78 C 660 82 740 44 960 48 C 1160 52 1240 22 1440 28"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'SectionDivider',

  props: {
    // Colour of the section above (the curve's fill).
    from: {
      type: String,
      default: '#001116'
    },
    // Colour of the section below (shown beneath the curve).
    to: {
      type: String,
      default: '#ffffff'
    }
  },

  computed: {
    // Unique per instance so multiple dividers on one page don't share a gradient id.
    gradientId() {
      return `sectionDividerStroke-${this._uid}`
    }
  }
}
</script>

<style lang="postcss" scoped>
.SectionDivider {
  @apply w-full;
  line-height: 0;
  margin-top: -1px; /* tuck against the section above so no hairline seam shows */
}

.SectionDivider__svg {
  display: block;
  width: 100%;
  height: 72px;
}

.SectionDivider__line {
  filter: drop-shadow(0 1px 6px rgba(252, 76, 1, 0.35));
}

@media only screen and (min-width: theme('screens.md')) {
  .SectionDivider__svg {
    height: 120px;
  }
}
</style>
